import { IGridColumnDefinition } from "./grid-columns/models";
import { IGridFilterDefinition } from "./grid-filters/models";
import { IGridSortingDefinition } from "./grid-sorting/models";
import { toKeyMap } from "@gtmhub/util";

export const toGridDefinitionMap = <Definition extends IGridColumnDefinition | IGridFilterDefinition | IGridSortingDefinition>(
  definitions: Definition[]
): Record<string, Definition> => toKeyMap("fieldName", definitions);
